// extracted by mini-css-extract-plugin
export default {"wrapper":"ui_wrapper__SrCyf"};